<template>
  <v-banner data-aos="flip-down" data-aos-duration="3000" v-model="show" two-line>
    <v-avatar slot="icon" color="primary" size="40">
      <v-icon icon="school" color="white"> school </v-icon>
    </v-avatar>

    {{ text }}

    <template v-slot:actions>
      <v-btn text color="primary" @click="$emit('ok')"> Ok </v-btn>
    </template>
  </v-banner>
</template>

<script>
export default {
  props: {
    show: Boolean,
    text: String,
    action: Number,
  },
};
</script>

<style>
</style>